'use client';
import React, { useEffect, useState } from 'react';
import { getCookie } from 'typescript-cookie';
import CrossSellItemsListCarousel from '@/components/customercenter-ui/components/home/crossSellItemsListCarousel';
import { COOKIE_KEYS } from '../../../../../constants/constant';
const CrossSellItemsListCarouselTastic = (data: any) => {
  const [siteId, setSiteId] = useState<string>();
  const { text, maxAlsoBoughtContentPerPage } = data?.data;

  useEffect(() => {
    const cookieSiteId = getCookie(COOKIE_KEYS.selectedSite) ?? 'ZBSite';
    setSiteId(cookieSiteId);
  }, []);

  return (
    <CrossSellItemsListCarousel
      data={data}
      title={text}
      siteId={siteId}
      maxAlsoBoughtContentPerPage={maxAlsoBoughtContentPerPage}
      crossSell={true}
    />
  );
};

export default CrossSellItemsListCarouselTastic;
